export const SS_HANDOFF_TARGETS = {
  ssmedia: {
    id: 'ss-handoff-ssmedia',
    text: "SSMedia'ya geç",
    path: '/ss-gecis/ssmedia',
    icon: 'export',
  },
  sschatbot: {
    id: 'ss-handoff-sschatbot',
    text: "SSChatbot'a geç",
    path: '/ss-gecis/sschatbot',
    icon: 'export',
  },
};

const COMPANY_SLUGS = {
  fixhair: 'fixhair',
};

export function isPointYonetici(user) {
  if (!user) return false;
  const admin = user.KUL_ISADMIN;
  return admin === true || admin === 1 || admin === '1' || Number(user.KUL_YETKI) === 0;
}

export function foldFirmaAdi(firmaAdi) {
  return String(firmaAdi || '')
    .trim()
    .replace(/İ/g, 'i')
    .replace(/I/g, 'i')
    .replace(/ı/g, 'i')
    .toLowerCase();
}

export function pointFirmaSlug(firmaAdi) {
  return COMPANY_SLUGS[foldFirmaAdi(firmaAdi)] || null;
}

export function currentPointFirmaAdi(user, firms) {
  const list = Array.isArray(firms) ? firms : [];
  const ref = user?.KUL_DEF_FIR_REF ?? user?.KUL_FIR_REF;
  if (ref == null || ref === '') return '';
  const firm = list.find((item) => Number(item?.FIR_REF) === Number(ref));
  return firm?.FIR_ADI || '';
}

function isSsmediaMenu(item) {
  const path = String(item?.path || '').replace(/^\//, '').trim().toLowerCase();
  const text = String(item?.text || '').trim().toLowerCase();
  return path === 'ssmedia' || text === 'ssmedia';
}

function handoffItem(target) {
  const spec = SS_HANDOFF_TARGETS[target];
  return {
    text: spec.text,
    path: spec.path,
    icon: spec.icon,
    id: spec.id,
    handoffTarget: target,
  };
}

export function appendSsHandoffMenu(items, context = {}) {
  const list = Array.isArray(items) ? items : [];
  if (!isPointYonetici(context.user)) return list;
  if (pointFirmaSlug(currentPointFirmaAdi(context.user, context.firms)) !== 'fixhair') return list;

  const links = [handoffItem('ssmedia'), handoffItem('sschatbot')];
  const parent = list.find(isSsmediaMenu);
  if (!parent) {
    return [
      ...list,
      {
        text: 'SSMEDIA',
        path: '/ssmedia',
        icon: 'message',
        id: 'ssmedia-handoff-root',
        items: links,
      },
    ];
  }

  const existing = new Set((parent.items || []).map((item) => item.handoffTarget || item.path));
  const missing = links.filter((item) => !existing.has(item.handoffTarget) && !existing.has(item.path));
  if (!missing.length) return list;
  parent.items = [...(parent.items || []), ...missing];
  return list;
}
